import { render, staticRenderFns } from "./paperViewer.vue?vue&type=template&id=054bd482&"
import script from "./paperViewer.vue?vue&type=script&lang=js&"
export * from "./paperViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports